import { type SVGProps } from 'react'
import { cn } from '#app/utils/misc.tsx'

export function SyrchaLogo({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 426 497"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={cn('h-8 w-8', className)}
			{...props}
		>
			<path
				d="M213 0L426 71V266.25C426 372.75 319.5 461.5 213 497C106.5 461.5 0 372.75 0 266.25V71L213 0Z"
				fill="url(#paint0_linear_436_2)"
			/>
			<path
				d="M213 0L426 71V266.25C426 372.75 319.5 461.5 213 497C106.5 461.5 0 372.75 0 266.25V71L213 0Z"
				fill="url(#paint1_linear_436_2)"
			/>
			<path
				d="M212.729 38L390.458 94.125V267.177C390.458 351.365 299.255 426.198 212.729 458.938C126.203 426.198 35 351.365 35 267.177V94.125L212.729 38Z"
				fill="#292929"
			/>
			<path
				d="M212.729 38L390.458 94.125V267.177C390.458 351.365 299.255 426.198 212.729 458.938C126.203 426.198 35 351.365 35 267.177V94.125L212.729 38Z"
				fill="url(#paint2_linear_436_2)"
				fillOpacity={0.2}
			/>
			<path
				d="M108 253.849L178.156 324.005L318.469 172"
				stroke="url(#paint3_linear_436_2)"
				strokeWidth={34}
				strokeLinejoin="round"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_436_2"
					x1="6.83239e-07"
					y1="204"
					x2="426"
					y2="202"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.5" stopColor="#8664E3" />
					<stop offset="0.5" stopColor="#4F3489" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_436_2"
					x1="6.83239e-07"
					y1="204"
					x2="426"
					y2="202"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.5" stopColor="#8664E3" />
					<stop offset="0.5" stopColor="#4F3489" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_436_2"
					x1="35"
					y1="248.313"
					x2="390.458"
					y2="248.624"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset={0.5} stopColor="#565656" />
					<stop offset={0.5} stopColor="#373636" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_436_2"
					x1="108"
					y1="248.276"
					x2="318.469"
					y2="247.729"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#BAB9B9" />
					<stop offset={1} stopColor="#979797" />
				</linearGradient>
			</defs>
		</svg>
	)
}
